interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems: NavData[] = [

  // #region Main Navigation URLs //
  // {
  //   name: 'Dashboard',
  //   url: '/dashboard',
  //   icon: 'icon-speedometer',
  //   badge: {
  //     variant: 'info',
  //     text: ''
  //   }
  // },
  {
    name: 'Home',
    url: '/home',
    icon: 'icon-home',
    badge: {
      variant: 'info',
      text: ''
    }
  },

  {
    name: 'Members',
    url: '/members',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Parents',
        url: '/members/parents',
        icon: 'icon-parents'
      },
      {
        name: 'Trainees',
        url: '/members/trainees',
        icon: 'icon-trainees'
      },
      {
        name: 'Specialists',
        url: '/members/specialists',
        icon: 'icon-specialists'
      }
    ]
  },

  {
    name: 'Courses',
    url: '/courses',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Courses List',
        url: '/courses',
        icon: 'icon-courseslist'
      }
      , {
        name: 'New Course',
        url: '/courses/course',
        icon: 'icon-newcourse'
      }
    ]
  },
  {
    name: 'Articles',
    url: '/articles',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Articles List',
        url: '/articles',
        icon: 'icon-articleslist'
      }
      , {
        name: 'New Article',
        url: '/articles/article-details',
        icon: 'icon-newarticle'
      }
    ]
  }

  , {
    name: 'Events',
    url: '/events',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Events List',
        url: '/events',
        icon: 'icon-eventslist'
      }
      ,
      {
        name: 'New Event',
        url: '/events/event',
        icon: 'icon-newevent'
      }
    ]
  }

  , {
    name: 'Services',
    url: '/services',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Services List',
        url: '/services',
        icon: 'icon-serviceslist'
      }
      ,
      {
        name: 'New Service',
        url: '/services/service',
        icon: 'icon-newservice'
      }
    ]
  }

  , {
    name: 'Sessions',
    url: '/members',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Session Requests',
        url: '/members/sessionRequests',
        icon: 'icon-sessionRequests'
      }
    ]
  }
  , {
    name: 'Videos',
    url: '/videos',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Videos List',
        url: '/videos',
        icon: 'icon-videos'
      },
      {
        name: 'New video',
        url: '/videos/video',
        icon: 'icon-video'
      }
    ]
  }
  , {
    name: 'Faqs',
    url: '/faqs',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Faqs List',
        url: '/faqs',
        icon: 'icon-faqs'
      },
      {
        name: 'New FAQ',
        url: '/faqs/faq',
        icon: 'icon-faq'
      }
    ]
  },
  {
    name: 'Stories',
    url: '/stories',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Stories List',
        url: '/stories',
        icon: 'icon-faqs'
      },
      {
        name: 'New Story',
        url: '/stories/story',
        icon: 'icon-faq'
      }
    ]
  }
  // #end region //




  // {
  //   name: 'Buttons',
  //   url: '/buttons',
  //   icon: 'icon-cursor',
  //   children: [
  //     {
  //       name: 'Buttons',
  //       url: '/buttons/buttons',
  //       icon: 'icon-cursor'
  //     },
  //     {
  //       name: 'Dropdowns',
  //       url: '/buttons/dropdowns',
  //       icon: 'icon-cursor'
  //     },
  //     {
  //       name: 'Brand Buttons',
  //       url: '/buttons/brand-buttons',
  //       icon: 'icon-cursor'
  //     }
  //   ]
  // },

  // {
  //   title: true,
  //   name: 'Theme'
  // },
  // {
  //   name: 'Colors',
  //   url: '/theme/colors',
  //   icon: 'icon-drop'
  // },
  // {
  //   name: 'Typography',
  //   url: '/theme/typography',
  //   icon: 'icon-pencil'
  // },

  // {
  //   title: true,
  //   name: 'Components'
  // },

  // {
  //   name: 'Base',
  //   url: '/base',
  //   icon: 'icon-puzzle',
  //   children: [
  //     {
  //       name: 'Cards',
  //       url: '/base/cards',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Carousels',
  //       url: '/base/carousels',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Collapses',
  //       url: '/base/collapses',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Forms',
  //       url: '/base/forms',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Pagination',
  //       url: '/base/paginations',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Popovers',
  //       url: '/base/popovers',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Progress',
  //       url: '/base/progress',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Switches',
  //       url: '/base/switches',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Tables',
  //       url: '/base/tables',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Tabs',
  //       url: '/base/tabs',
  //       icon: 'icon-puzzle'
  //     },
  //     {
  //       name: 'Tooltips',
  //       url: '/base/tooltips',
  //       icon: 'icon-puzzle'
  //     }
  //   ]
  // },  

  // {
  //   name: 'Charts',
  //   url: '/charts',
  //   icon: 'icon-pie-chart'
  // },


  // {
  //   name: 'Icons',
  //   url: '/icons',
  //   icon: 'icon-star',
  //   children: [
  //     {
  //       name: 'CoreUI Icons',
  //       url: '/icons/coreui-icons',
  //       icon: 'icon-star',
  //       badge: {
  //         variant: 'success',
  //         text: 'NEW'
  //       }
  //     },
  //     {
  //       name: 'Flags',
  //       url: '/icons/flags',
  //       icon: 'icon-star'
  //     },
  //     {
  //       name: 'Font Awesome',
  //       url: '/icons/font-awesome',
  //       icon: 'icon-star',
  //       badge: {
  //         variant: 'secondary',
  //         text: '4.7'
  //       }
  //     },
  //     {
  //       name: 'Simple Line Icons',
  //       url: '/icons/simple-line-icons',
  //       icon: 'icon-star'
  //     }
  //   ]
  // },

  // {
  //   name: 'Notifications',
  //   url: '/notifications',
  //   icon: 'icon-bell',
  //   children: [
  //     {
  //       name: 'Alerts',
  //       url: '/notifications/alerts',
  //       icon: 'icon-bell'
  //     },
  //     {
  //       name: 'Badges',
  //       url: '/notifications/badges',
  //       icon: 'icon-bell'
  //     },
  //     {
  //       name: 'Modals',
  //       url: '/notifications/modals',
  //       icon: 'icon-bell'
  //     }
  //   ]
  // },

  // {
  //   name: 'Widgets',
  //   url: '/widgets',
  //   icon: 'icon-calculator',
  //   badge: {
  //     variant: 'info',
  //     text: 'NEW'
  //   }
  // },  

  // {
  //   divider: true
  // },

  // {
  //   title: true,
  //   name: 'Extras',
  // },

  // {
  //   name: 'Pages',
  //   url: '/pages',
  //   icon: 'icon-star',
  //   children: [
  //     {
  //       name: 'Login',
  //       url: '/login',
  //       icon: 'icon-star'
  //     },
  //     {
  //       name: 'Register',
  //       url: '/register',
  //       icon: 'icon-star'
  //     },
  //     {
  //       name: 'Error 404',
  //       url: '/404',
  //       icon: 'icon-star'
  //     },
  //     {
  //       name: 'Error 500',
  //       url: '/500',
  //       icon: 'icon-star'
  //     }
  //   ]
  // },

  // {
  //   name: 'Disabled',
  //   url: '/dashboard',
  //   icon: 'icon-ban',
  //   badge: {
  //     variant: 'secondary',
  //     text: 'NEW'
  //   },
  //   attributes: { disabled: true },
  // }
];
